import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c73390f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-info" }
const _hoisted_2 = { class: "goods-attr" }
const _hoisted_3 = {
  key: 0,
  class: "goods-attr-item"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "brand-name" }, "退款类型：")
], -1))
const _hoisted_5 = { class: "attr-right" }
const _hoisted_6 = { class: "goods-attr-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "brand-name" }, "退款金额：")
], -1))
const _hoisted_8 = { class: "attr-right" }
const _hoisted_9 = { class: "goods-attr-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "brand-name" }, "退款原因：")
], -1))
const _hoisted_11 = { class: "attr-right" }
const _hoisted_12 = { class: "goods-attr-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "brand-name" }, "退款说明：")
], -1))
const _hoisted_14 = { class: "attr-right" }
const _hoisted_15 = {
  key: 0,
  class: "goods-img"
}
const _hoisted_16 = { class: "goods-img-item" }
const _hoisted_17 = ["src"]

import { postSaleType } from "@/utils/apitype/postSaleType"
import { inject, ref } from "vue"

interface Props {
  postSale: postSaleType | undefined
}

export default /*#__PURE__*/_defineComponent({
  __name: 'GoodsPostSale',
  props: {
    postSale: { default: undefined }
  },
  setup(__props: any) {

const { postSale } = __props as { postSale: postSaleType | undefined };



let postSaleInfo = postSale as postSaleType

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(postSaleInfo).sales_type != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(postSaleInfo).sales_type == 1 ? "未发货售后" : "已发货售后") + _toDisplayString(_unref(postSaleInfo).service_type == 1 ? "仅退款（无需退货）" : "退货退款"), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, "¥" + _toDisplayString(_unref(postSaleInfo).money), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(postSaleInfo).explain), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(postSaleInfo).reason), 1)
      ])
    ]),
    (_unref(postSaleInfo).pics && _unref(postSaleInfo).pics.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(postSaleInfo).pics.split(','), (pic, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("img", { src: pic }, null, 8, _hoisted_17)
            ]))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})